import * as ActionTypes from "../ActionTypes.js";

export const claimReducer = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.GET_CLAIMS:
      return action.payload;
    case ActionTypes.UNCLAIM:
      return state.filter(
        (claim) =>
          claim.foundItemId !== action.payload.foundItemId &&
          claim.claimerUsername !== action.payload.claimerUsername
      );
    default:
      return state;
  }
};
